import type { SVGProps } from 'react';
const SvgChannelTelegram = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} fill="none" {...props}>
    <g clipPath="url(#channel-telegram_svg__a)">
      <path
        fill="url(#channel-telegram_svg__b)"
        d="M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24"
      />
      <path
        fill="#fff"
        d="m16.77 25.74-5.76-1.873s-.688-.278-.466-.91c.046-.13.138-.242.413-.433 1.276-.887 23.618-8.904 23.618-8.904s.63-.213 1.003-.072a.55.55 0 0 1 .37.404q.06.25.05.507c-.001.148-.02.285-.033.5-.136 2.191-4.208 18.55-4.208 18.55s-.244.957-1.117.99a1.6 1.6 0 0 1-1.165-.45c-1.713-1.47-7.633-5.443-8.941-6.317a.25.25 0 0 1-.108-.176c-.018-.093.082-.207.082-.207s10.31-9.148 10.584-10.108c.021-.075-.06-.111-.167-.079-.685.252-12.554 7.735-13.864 8.56a.6.6 0 0 1-.291.019"
      />
    </g>
    <defs>
      <linearGradient
        id="channel-telegram_svg__b"
        x1={24}
        x2={24}
        y1={48}
        y2={0}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1D93D2" />
        <stop offset={1} stopColor="#38B0E3" />
      </linearGradient>
      <clipPath id="channel-telegram_svg__a">
        <path fill="#fff" d="M0 0h48v48H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgChannelTelegram;
